import React, { useCallback, useState } from 'react'
import { Waypoint } from 'react-waypoint'

import { Column, Row, Text } from 'Components/UI'

import { useResponsiveLayout } from 'Hooks'

import { GROW_SECTION_STATISTIC_ITEMS } from './constants'
import ScoringNumber from './ScoringNumber'
import { Container } from './styles'

function GrowSectionStatistic() {
  const { isMobile } = useResponsiveLayout()

  const [visibleOdometerIds, setVisibleOdometerIds] = useState<Set<string>>(
    new Set(),
  )

  const handleWaypointEnter = useCallback((id: string) => {
    setVisibleOdometerIds(prev => {
      if (prev.has(id)) return prev
      const next = new Set(prev)
      next.add(id)
      return next
    })
  }, [])

  return (
    <Container
      gridTemplateColumns={[
        'repeat(2, 1fr)',
        'repeat(2, 1fr)',
        'repeat(2, 1fr)',
        'repeat(4, 1fr)',
      ]}
      p={[5, 5, 11]}
    >
      {GROW_SECTION_STATISTIC_ITEMS.map(item => (
        <Column alignCenter gap={4} key={item.id}>
          <Waypoint
            bottomOffset="5%"
            onEnter={() => handleWaypointEnter(item.id)}
          />

          <Row alignEnd>
            <Text as="div" bold screen64 success>
              <ScoringNumber
                shouldAnimate={!!visibleOdometerIds?.has(item.id)}
                targetNumber={item.number}
              />
            </Text>

            <Text as="span" bold screen32 success>
              %
            </Text>
          </Row>

          <Text
            center
            inverse
            medium
            preWrap
            screen16={isMobile}
            screen20={!isMobile}
          >
            {item.caption}
          </Text>
        </Column>
      ))}
    </Container>
  )
}

export default GrowSectionStatistic
